const SwazilandSvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112480)">
      <path
        d="M38.0155 28.6954C39.2869 26.0661 40 23.1162 40 19.9998C40 16.8834 39.2869 13.9335 38.0155 11.3042L20 10.4346L1.98453 11.3041C0.713125 13.9335 0 16.8834 0 19.9998C0 23.1162 0.713125 26.0661 1.98453 28.6954L20 29.565L38.0155 28.6954Z"
        fill="#FFDA44"
      />
      <path
        d="M19.9998 0C12.0706 0 5.21938 4.61445 1.98438 11.3044H38.0152C34.7803 4.61445 27.929 0 19.9998 0Z"
        fill="black"
      />
      <path
        d="M19.9998 39.9997C12.0706 39.9997 5.21938 35.3852 1.98438 28.6953H38.0152C34.7803 35.3852 27.929 39.9997 19.9998 39.9997Z"
        fill="#0052B4"
      />
      <path
        d="M39.0555 13.9131H0.944453C0.331797 15.8325 0 17.8775 0 20C0 22.1226 0.331797 24.1675 0.944453 26.087H39.0555C39.6682 24.1675 40 22.1226 40 20C40 17.8775 39.6682 15.8325 39.0555 13.9131Z"
        fill="#A2001D"
      />
      <path d="M6.95654 19.1299H33.0435V20.869H6.95654V19.1299Z" fill="#FFDA44" />
      <path d="M10.4351 15.6514H29.5655V17.3905H10.4351V15.6514Z" fill="#FFDA44" />
      <path
        d="M29.6896 20.0006C29.6896 20.0006 25.2175 25.218 20.0001 25.218C14.7828 25.218 14.7827 20.0006 14.7827 20.0006C14.7827 20.0006 14.7827 14.7832 20.0001 14.7832C25.2176 14.7832 29.6896 20.0006 29.6896 20.0006Z"
        fill="#F0F0F0"
      />
      <path
        d="M20 25.218C14.7826 25.218 10.3105 20.0006 10.3105 20.0006C10.3105 20.0006 14.7826 14.7832 20 14.7832"
        fill="black"
      />
      <path d="M16.5215 18.2598H18.2606V21.738H16.5215V18.2598Z" fill="#F0F0F0" />
      <path d="M21.7393 18.2598H23.4784V21.738H21.7393V18.2598Z" fill="black" />
      <path
        d="M6.95643 21.738C7.91693 21.738 8.69557 20.9594 8.69557 19.9989C8.69557 19.0384 7.91693 18.2598 6.95643 18.2598C5.99593 18.2598 5.21729 19.0384 5.21729 19.9989C5.21729 20.9594 5.99593 21.738 6.95643 21.738Z"
        fill="#0052B4"
      />
      <path
        d="M33.0433 21.738C34.0038 21.738 34.7825 20.9594 34.7825 19.9989C34.7825 19.0384 34.0038 18.2598 33.0433 18.2598C32.0828 18.2598 31.3042 19.0384 31.3042 19.9989C31.3042 20.9594 32.0828 21.738 33.0433 21.738Z"
        fill="#0052B4"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112480">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default SwazilandSvg;
